import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useToast } from '@shared/hooks/use-toast';
import { PickingApiAdapter } from '../adapters/PickingApiAdapter';
import type { AdjustPickingDiscrepancyPayload, AdjustPickingDiscrepancyResponse } from '../models';
import { mapAdjustDiscrepancyErrorMessage } from '../utils/adjustDiscrepancyErrorMapper';

export interface AdjustDiscrepancyMutationVariables {
  preparationId: number;
  payload: AdjustPickingDiscrepancyPayload;
}

export const useAdjustDiscrepancyPreview = () => {
  const { toast } = useToast();
  const { t } = useTranslation('pickingModule');
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new PickingApiAdapter(httpClient);

  return useMutation<AdjustPickingDiscrepancyResponse, Error, AdjustDiscrepancyMutationVariables>({
    mutationFn: ({ preparationId, payload }) => adapter.previewAdjustDiscrepancy(preparationId, payload),
    onError: (error) => {
      toast({
        title: t('adjust_discrepancy.toast.preview_error_title'),
        description: mapAdjustDiscrepancyErrorMessage(error, t),
        variant: 'destructive',
      });
    },
  });
};
